import React, {useRef, useCallback, useState, useEffect} from 'react';
import {useTags} from './useTags.js';
import {SEQUENCE_TAG} from 'constants/annotation-types.js';
import ethereum from 'decentralized/ethereum.js';
import PulseLoader from 'react-spinners/PulseLoader'
import {connect} from 'react-redux';

const TagEditor = ({work}) => {
    const [text, setText] = useState('');
    const ref = useRef(undefined);
    const {newTag, setTags, tags} = useTags({work});

    const onChange = useCallback((e) => {
        setText(e.target.value);
    }, [setText]);

    useEffect(() => {
        if (ref.current) {
            ref.current.focus();
        }
    }, []);

    const tag = useCallback(() => {
        newTag(text);
        setText('');
    }, [setText, text, tags, work, setTags]);

    return (
        <div className="tags-editor">
          <div className="input-container">
            <input
              ref={ref}
              placeholder="Type tag here"
              className="tags-input" type="text" onChange={onChange} value={text}/>
            <div
              onClick={tag}
              className="tag-button">
              Tag
            </div>
          </div>
          <div className="work-tags">
            {tags.map(x => <div className="work-tag">{x}</div>)}
          </div>
        </div>
    );
};

export default connect(null, null)(TagEditor);

